<template>
  <div class="boxis">
    <div id="container">
      <div class="titles">
        <h2>{{ content.relicId_dictText }}</h2>
      </div>
    </div>
    <div class="progress" v-show="shows">
      <img class="img" src="@/assets/three-tu@3x.png" alt="">
      <div class="inner-progress">
        <img src="@/assets/three-tiao@3x.png" alt="">
        <div class="box-progress">
          <div :style="'width: ' + percentage + '%'">
            <img src="@/assets/three-wen@3x.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import axios from 'axios'
export default {
  data () {
    return {
      camera: null,
      scene: null,
      renderer: null,
      controls: null,
      modelPath: process.env.BASE_URL,
      // 进度条
      percentage: 0,
      colors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#cccccc', percentage: 100 }
      ],
      shows: true,
      xz: true,
      fbxs: '',
      id: '',
      content: '',
      bgimg: '',
      // light: new THREE.SpotLight('#ffffff')
      light: new THREE.AmbientLight('#ffffff')
    }
  },
  methods: {
    init () {
      const self = this
      const container = document.getElementById('container')
      self.camera = new THREE.PerspectiveCamera(
        45,
        container.clientWidth / container.clientHeight,
        0.01,
        10000
      )
      self.camera.position.set(100, 200, 1500)
      self.scene = new THREE.Scene()
      // ground
      var mesh = new THREE.Mesh(
        new THREE.PlaneBufferGeometry(0, 0),
        new THREE.MeshPhongMaterial({ color: 0x999999, depthWrite: false })
      )
      mesh.rotation.x = -Math.PI / 2
      self.scene.scale.set(10, 10, 10)
      self.scene.add(mesh)
      self.renderer = new THREE.WebGLRenderer({
        alpha: true, // 是否包含透明度
        antialias: true, // 是否执行抗锯齿
        logarithmicDepthBuffer: true,
        ogarithmicDepthBuffer: true,
        failIfMajorPerformanceCaveat: true // 检测渲染器是否会因性能过差而创建失败
      })
      // self.renderer.shadowMap.enabled = true
      self.renderer.setClearAlpha(0)
      // https://daolansaasapi.chwhyun.cn
      axios.get(`https://daolansaasapi.chwhyun.cn/jeecg-boot/wechat/relicManage/ivCulturalRelicModel/queryByRelicId?id=${self.id}`, {
        headers: {
          tenant_id: sessionStorage.getItem('tenantId')
        }
      })
        .then(res => {
          console.log(res)
          this.content = res.data.result
          container.appendChild(self.renderer.domElement)
          self.controls = new OrbitControls(self.camera, self.renderer.domElement)
          self.controls.target.set(0, 0, 0)
          self.controls.update()
          self.renderer.setClearColor(0x000000, 0)
          self.renderer.setPixelRatio(window.devicePixelRatio)
          self.renderer.setSize(window.innerWidth, window.innerHeight)
          window.addEventListener('resize', self.onWindowResize, false)// 添加窗口监听事件（resize-onresize即窗口或框架被重新调整大小）
          document.getElementById('container').appendChild(self.renderer.domElement)
          // self.light.intensity = 2
          // self.scene.add(self.light)
          const fbxLoader = new FBXLoader()
          var textureLoader = new THREE.TextureLoader()
          console.log(res.data.result)
          this.fbxs = res.data.result.relicModel
          fbxLoader.load(res.data.result.relicModel, function (object) {
            var mat = new THREE.MeshStandardMaterial()
            mat.color = new THREE.Color('#cccccc')
            mat.roughness = 100
            mat.metalness = 200
            console.log(object)
            self.scene.add(mat)
            self.scene.add(object)
            textureLoader.load(res.data.result.relicModelPic, (texture) => {
              object.children[0].material = new THREE.MeshBasicMaterial({ map: texture })
              // object.children[0].material.map = texture
              object.children[0].material.needsUpdate = true
              this.scene.add(object)
              // this.renderer.render(this.scene, this.camera)
            })
          })
          this.lode(res.data.result.relicModel)
        })
      // getRecil({
      //   id: self.id
      // }).then(res => {
      //   console.log(res)
      //
      // })
      // self.$api.get('/jeecg-boot/wechat/relicManage/ivCulturalRelicModel/queryByRelicId', { id: self.id },
      //   res => {
      //     console.log(res)
      //
      //   }
      // )
    },
    render () {
      // var vector = this.camera.position.clone()
      // this.light.position.set(vector.x, vector.y, vector.z) // 点光源位置
      this.renderer.render(this.scene, this.camera)// 执行渲染操作
    },
    // 窗口监听函数
    onWindowResize () {
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(window.innerWidth, window.innerHeight)
    },
    animate () {
      requestAnimationFrame(this.animate)
      this.render()
      // this.renderer.clear()
      this.renderer.render(this.scene, this.camera)
      // this.renderer.clearDepth()
    },
    lode (fbxs) {
      console.log(fbxs)
      var loader = new THREE.ObjectLoader()
      const _this = this
      loader.load(
        // 资源路径
        fbxs,

        // 加载完成后的回到函数
        function (obj) {
          // 资源加载完成后将对象加入场景
          this.scene.add(obj)
        },

        // 加载过程中的回调函数
        function (xhr) {
          _this.percentage = parseInt(xhr.loaded / xhr.total * 100)
          console.log(_this.percentage)
        }
        // 加载出错的回调
        // function ( err ) {
        //   console.error( 'An error happened' );
        // }
      )
    }
    // miuke() {
    //   var audio = document.getElementById("media");
    //   console.log(audio)
    //   if (audio.paused) { //判断当前的状态是否为暂停，若是则点击播放，否则暂停
    //     this.xz = !this.xz
    //     audio.play();
    //   } else {
    //     this.xz = !this.xz
    //     audio.pause();
    //   }
    // }
  },
  mounted () {
    sessionStorage.setItem('tenantId', this.$route.query.tenant_id)
    setTimeout(() => {
      document.title = this.$route.query.name
    }, 1000)
    this.id = this.$route.query.id
    this.init()
    this.animate()
  },
  updated () {
    if (this.percentage === 100) {
      setTimeout(() => {
        this.shows = false
      }, 1000)
    } else {
      this.shows = true
    }
  }
}

</script>
<style lang="scss" scoped>
.boxis {
  position: relative;
  height: 100%;
  background-image: url('../assets/three-bg@3x.png');
  background-size: 100% 100%;
}

/*无限旋转动画*/
@keyframes changDeg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.xz {
  animation: changDeg 2s linear 0.2s infinite;
}

#container {
  height: 100vh;
  width: 100%;

  > img {
    position: absolute;
    top: 20px;
    left: 25px;
    width: 100px;
  }

  .audio {
    display: none;
  }

  .yy {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 15px;
    top: 15px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .titles {
    position: absolute;
    width: 100%;
    left: 0;
    top: 70%;
    z-index: 100;
    h2 {
      background-image: url('../assets/three-biao@3x.png');
      background-size: 100% 100%;
      width: fit-content;
      font-size: 18px;
      padding: 2% 2%;
      color: #ae864f;
      margin: 10px auto;
      box-sizing: border-box;
    }

    p {
      text-indent: 2em;
      font-size: 12px;
      color: #ae864f;
    }
  }

}

.progress {
  position: absolute;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: url('../assets/three-bj@2x.png') center center / 110% 110% ;
  z-index: 1000;
  .img {
    width: 80%;
    position: absolute;
    right: 0;
    left: 0;
    top: -80px;
    bottom: 0;
    margin: auto;
    animation: rotate 10s linear infinite;
  }
  @keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(359deg)}
  }
  p {
    top: 72%;
    left: 95px;
    color: #fff;
    position: absolute;
    font-size: 30px;
  }
}
</style>
<style lang="scss">
.inner-progress {
  position: absolute;
  top: 80%;
  left: 0;
  margin: 0 8%;
  box-sizing: border-box;
  img {
    width: 100%;
  }

  .box-progress {
    position: absolute;
    width: 100%;
    height: 9px;
    padding: 0 3%;
    left: 0;
    top: 2.5px;
    box-sizing: border-box;
    div {
      position: relative;
      //width: 50%;
      height: 100%;
      box-sizing: border-box;
      border-radius: 50px;
      z-index: 1;
      background-color: #97A48D;
      img {
        position: absolute;
        right: -15px;
        top: -50px;
        width: 35px;
        height: 49px;
      }
    }
  }
}
</style>
